export default __webpack_public_path__ + "static/media/dispute-alert.69d0ccb2.svg";